import React from "react";
import { useNavigate } from "react-router-dom";
import UserAvatar from "./UserAvatar";

interface NavbarProps {
  pageTitle?: string;
}

const Navbar: React.FC<NavbarProps> = ({ pageTitle }) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-6xl mx-auto mb-4 sm:mb-6">
      <div className="glass-card mb-4 sm:mb-6 p-4 sm:p-5 rounded-2xl shadow-large">
        <div className="flex items-center">
          {/* Left: App title */}
          <div className="flex items-center space-x-2 flex-1">
            <button
              onClick={() => navigate("/")}
              className="w-8 h-8 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center shadow-soft hover:shadow-glow transition-all duration-200 touch-manipulation"
              aria-label="Go to home page"
            >
              <svg
                className="w-4 h-4 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </button>
            <button
              onClick={() => navigate("/")}
              className="hidden sm:block text-xl sm:text-2xl font-bold bg-gradient-to-r from-primary-600 to-accent-600 bg-clip-text text-transparent hover:from-primary-700 hover:to-accent-700 transition-all cursor-pointer"
            >
              Streak Spark
            </button>
          </div>

          {/* Center: Page title */}
          {pageTitle && (
            <div className="flex items-center justify-center flex-1">
              <span className="text-lg sm:text-xl font-bold text-neutral-900 dark:text-neutral-100 text-center">
                {pageTitle}
              </span>
            </div>
          )}

          {/* Right: User Avatar */}
          <div className="flex items-center justify-end flex-1">
            <UserAvatar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
